// Module
var code = "<react-component name=\"ManageWebsiteDesign\" props=\"{save: save, data: website, websiteUrl: websiteUrl(), reloadWebsite: reloadWebsite}\"></react-component>\n";
// Exports
module.exports = code;